var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LottieAnimation',{ref:"anim",attrs:{"animationData":require('@/assets/json/landing_svg.json'),"background":"transparent","loop":true,"autoPlay":true,"speed":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }